import { render, staticRenderFns } from "./RowSubstitutions.vue?vue&type=template&id=4c17ec0c&"
import script from "./RowSubstitutions.vue?vue&type=script&lang=js&"
export * from "./RowSubstitutions.vue?vue&type=script&lang=js&"
import style0 from "./RowSubstitutions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c17ec0c')) {
      api.createRecord('4c17ec0c', component.options)
    } else {
      api.reload('4c17ec0c', component.options)
    }
    module.hot.accept("./RowSubstitutions.vue?vue&type=template&id=4c17ec0c&", function () {
      api.rerender('4c17ec0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/substitutions/RowSubstitutions.vue"
export default component.exports